import { render, staticRenderFns } from "./ExercisePollComponent.vue?vue&type=template&id=766fa03c&"
import script from "./ExercisePollComponent.vue?vue&type=script&lang=js&"
export * from "./ExercisePollComponent.vue?vue&type=script&lang=js&"
import style0 from "./ExercisePollComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports